import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-card',
  templateUrl: './skeleton-card.component.html',
  styleUrl: './skeleton-card.component.css'
})
export class SkeletonCardComponent {

}
